module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay"
  }, [_c('navtop', {
    attrs: {
      "index": ''
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "money"
  }, [_vm._v("￥" + _vm._s(_vm.orderRmb))]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("购买内容:" + _vm._s(_vm.orderRmb / 10) + "万齐齐豆")]), _vm._v(" "), _c('div', {
    staticClass: "selectPaytype"
  }, [_vm._v("选择支付方式")]), _vm._v(" "), (_vm.isWx) ? _c('a', {
    staticClass: "wx",
    on: {
      "click": function($event) {
        return _vm.pay(26)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v("微信支付")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "zfb",
    on: {
      "click": function($event) {
        return _vm.pay(25)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v("支付宝支付")])]), _vm._v(" "), (_vm.openBrowser) ? _c('div', {
    staticClass: "cover",
    on: {
      "click": function($event) {
        _vm.openBrowser = false
      }
    }
  }, [_vm._m(0)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("充值请点击右上角"), _c('br'), _vm._v("通过浏览器打开支付")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34e674c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dating/pay.vue
// module id = 117
// module chunks = 0